import React from 'react';
import { Menu } from 'semantic-ui-react';
import { tl } from 'common/services/i18nService';
import moment from 'moment';
import * as styles from './EvaluatorPopUpBox.scss';
import { SIMPLE_DATE_FORMAT_STRING_WITH_SECONDS } from '../../store/common/constants';

interface EvaluatorPopUpBoxProps{
    evaluatorName: string;
    email: string;
    lastLogin: string;
    workflowState?: string;
}

const EvaluatorPopUpBox = ({
    evaluatorName,
    email,
    lastLogin,
    workflowState = '',
}: EvaluatorPopUpBoxProps) => {
    const lastLoginMoment = moment.utc(lastLogin, SIMPLE_DATE_FORMAT_STRING_WITH_SECONDS);
    return (
        <Menu.Item className={styles.popUpItem}>
            <React.Fragment>
                <div className={styles.popUpHeader}>
                    <strong>{evaluatorName}</strong>
                    <span>{email}</span>
                </div>
                {workflowState && (
                    <div className={styles.popUpWorkflowState}>
                        <span>{workflowState}</span>
                    </div>
                )}
                <div className={styles.popUpWorkLastLogin}>
                    <span>
                        {lastLogin
                            ? `${tl('grading.workflowInfo.waitingGrader.lastlogin')} ${lastLoginMoment.local().fromNow()}`
                            : tl('grading.workflowInfo.waitingGrader.neverLogin')}
                    </span>
                </div>
            </React.Fragment>
        </Menu.Item>
    );
};


export default EvaluatorPopUpBox;
